import { API } from '@apis/endPoints';
import { axiosService, checkError } from '@services';

export default async function getAddress(plant_id) {
  const res = await axiosService({
    method: 'post',
    data: {
      path: `/location`,
      plant_id: plant_id,
    },
    apiPath: `${API.PLANT_MANAGEMENT}`,
  });

  const data = res?.data?.result;

  if (res?.codeHTTP === 200 && data && data.address?.city && data.address?.zipCode && data.timezone) {
    return data;
  } else {
    return checkError(res, getAddress, plant_id);
  }
}

// const apiAddress = async () => {
//   const res = await axiosService({
//     method: 'post',
//     params: {
//       path: `/location`,
//       // eslint-disable-next-line camelcase
//       plant_id: id,
//     },
//     apiPath: `${API.PLANT_MANAGEMENT}`,
//   });
//   const data = res?.data?.result;
//   if (res?.codeHTTP === 200 && data && data.address?.city && data.address?.zipCode && data.timezone) {
//     setAddress({
//       city: data.address.city + ' ' + data.address.zipCode,
//       timezone: data.timezone,
//     });
//   } else {
//     await checkError(res, apiAddress);
//   }
// };
